export class ActiveWindow {
    public start: Date
    public end: Date

    constructor(days: Date[]) {
        this.start = days?.length ? days[0] : null
        this.end = days?.length ? days[days.length - 1] : null
    }

    includes(day: Date) {
        const isBeforeActiveWindow = day?.getTime() < this.start?.getTime()
        const isAfterActiveWindow = day?.getTime() > this.end?.getTime()

        return !isBeforeActiveWindow && !isAfterActiveWindow
    }
}
